import React from 'react';

interface PainScaleSegmentedProps {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

const SCALE = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const colorFor = (n: number, selected: boolean): string => {
  if (!selected) {
    return 'bg-white text-slate-600 border-slate-200 hover:border-slate-400';
  }
  if (n === 0) return 'bg-emerald-500 text-white border-emerald-500';
  if (n <= 3) return 'bg-emerald-400 text-white border-emerald-400';
  if (n <= 6) return 'bg-amber-400 text-white border-amber-400';
  if (n <= 8) return 'bg-orange-500 text-white border-orange-500';
  return 'bg-red-600 text-white border-red-600';
};

const PainScaleSegmented: React.FC<PainScaleSegmentedProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="flex flex-wrap gap-1">
    {SCALE.map((n) => {
      const selected = value === n;
      return (
        <button
          key={n}
          type="button"
          disabled={disabled}
          aria-pressed={selected}
          onClick={() => onChange(selected ? null : n)}
          className={`h-9 w-9 rounded-md border text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${colorFor(n, selected)}`}
        >
          {n}
        </button>
      );
    })}
  </div>
);

export default PainScaleSegmented;
